import { setErrorAction,unSetErrorAction, setLoadingAction, unSetLoadingAction } from "../actionCreators/errorActionCreator";


export const setErrorHandler = (errorType, error) => (dispatch) => {
  dispatch(setErrorAction(errorType, error));
};
export const unSetErrorHandler = () => (dispatch) => {
  dispatch(unSetErrorAction());
};

export const setLoadingHandler = () => (dispatch) => {
  dispatch(setLoadingAction());
};
export const unSetLoadingHandler = () => (dispatch) => {
  dispatch(unSetLoadingAction());
};
